import React, { ReactNode } from 'react';
import styles from './process-button-layout.module.scss';

type Props = {
  left?: ReactNode;
  right: ReactNode;
};

export const ProcessButtonLayout: React.FC<Props> = ({ left, right }) => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>{left}</div>
      <div className={styles.container}>{right}</div>
    </div>
  );
};
